export const BrandMark = ({ logoSize = 30, textClass = "text-[#4A0000]", textSize = "text-2xl", showText = true }) => (
  <div className="flex items-baseline" data-testid="brand-mark">
    <span className={`font-display ${textSize} ${textClass} leading-none uppercase tracking-[0.1em]`} style={{ fontWeight: 700 }}>
      Reelty
    </span>
  </div>
);
